import { useState, useEffect } from 'react';
import styles from './question-form-component.module.css';
import PlaceholderImage from '../../../assets/ai-readiness/placeholderimage.png';
import AiReadinessHeader from '../AiReadinessHeader';

export default function AiReadinessLayout({ FormComponent, Image = PlaceholderImage }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 1024);

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Preload image
    useEffect(() => {
        const imgElement = new window.Image();
        imgElement.src = Image;
    }, [Image]);

    return (
        <div
            className={styles.maincontainer}
            style={{ '--bg-image': `url(${Image})` }}
        >
            <AiReadinessHeader />
            <div className={styles.gridContainer}>
                <div className={styles.formWrapper}>
                    <FormComponent />
                </div>
                <div className={styles.QuestionFormimage}>
                    <img src={Image} alt="placeholderimage" loading="lazy"/>
                </div>
            </div>
        </div>
    )
}